// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("./MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_asrt_apply = require("./MM_asrt_apply.res.js");
var MM_proof_tree = require("./MM_proof_tree.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("./MM_parenCounter.res.js");
var MM_substitution = require("./MM_substitution.res.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");
var MM_apply_asrt_matcher = require("./MM_apply_asrt_matcher.res.js");

function bottomUpProverParamsMakeDefault(asrtLabel, maxSearchDepthOpt, lengthRestrictOpt, allowNewDisjForExistingVarsOpt, allowNewStmtsOpt, allowNewVarsOpt, args0Opt, args1Opt, maxNumberOfBranches) {
  var maxSearchDepth = maxSearchDepthOpt !== undefined ? maxSearchDepthOpt : 4;
  var lengthRestrict = lengthRestrictOpt !== undefined ? lengthRestrictOpt : "Less";
  var allowNewDisjForExistingVars = allowNewDisjForExistingVarsOpt !== undefined ? allowNewDisjForExistingVarsOpt : true;
  var allowNewStmts = allowNewStmtsOpt !== undefined ? allowNewStmtsOpt : true;
  var allowNewVars = allowNewVarsOpt !== undefined ? allowNewVarsOpt : false;
  var args0 = args0Opt !== undefined ? args0Opt : [];
  var args1 = args1Opt !== undefined ? args1Opt : [];
  return {
          maxSearchDepth: maxSearchDepth,
          frameParams: [
            {
              minDist: 0,
              maxDist: 0,
              frmsToUse: Belt_Option.map(asrtLabel, (function (label) {
                      return [label];
                    })),
              matches: undefined,
              args: args0,
              allowNewDisjForExistingVars: allowNewDisjForExistingVars,
              allowNewStmts: allowNewStmts,
              allowNewVars: allowNewVars,
              lengthRestrict: "No",
              maxNumberOfBranches: maxNumberOfBranches
            },
            {
              minDist: 1,
              maxDist: undefined,
              frmsToUse: undefined,
              matches: undefined,
              args: args1,
              allowNewDisjForExistingVars: allowNewDisjForExistingVars,
              allowNewStmts: allowNewStmts,
              allowNewVars: false,
              lengthRestrict: lengthRestrict,
              maxNumberOfBranches: maxNumberOfBranches
            }
          ]
        };
}

function lengthRestrictToStr(len) {
  switch (len) {
    case "No" :
        return "No";
    case "LessEq" :
        return "LessEq";
    case "Less" :
        return "Less";
    
  }
}

function lengthRestrictFromStr(str) {
  switch (str) {
    case "Less" :
        return "Less";
    case "LessEq" :
        return "LessEq";
    case "No" :
        return "No";
    default:
      return ;
  }
}

function lengthRestrictFromStrExn(str) {
  var v = lengthRestrictFromStr(str);
  if (v !== undefined) {
    return v;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot convert '" + str + "' to lengthRestrict."
        },
        Error: new Error()
      };
}

function findNonAsrtParent(tree, expr) {
  if (MM_proof_tree.ptIsNewVarDef(tree, expr)) {
    return "VarType";
  }
  var hyp = MM_proof_tree.ptGetHypByExpr(tree, expr);
  if (hyp !== undefined) {
    return {
            TAG: "Hypothesis",
            label: hyp.label
          };
  }
  
}

function findAsrtParentsWithoutNewVars(tree, expr, restrictExprLen, frameRestrict, onResult) {
  var exprLen = expr.length;
  MM_substitution.frmsForEach(MM_proof_tree.ptGetFrms(tree), expr[0], (function (frm) {
          if (!MM_context.frameIsAllowed(frm.frame, frameRestrict)) {
            return ;
          }
          var frmExpr = frm.frame.asrt;
          MM_substitution.iterateSubstitutions(frmExpr, expr, frm.frmConstParts[frm.numOfHypsE], frm.constParts[frm.numOfHypsE], frm.varGroups[frm.numOfHypsE], frm.subs, MM_proof_tree.ptGetParenCnt(tree), (function (subs) {
                  if (subs.isDefined.every(function (b) {
                          return b;
                        }) && Belt_Option.isNone(MM_substitution.verifyDisjoints(frm.frame.disj, subs, (function (extra, extra$1) {
                                return MM_proof_tree.ptIsDisjInCtx(tree, extra, extra$1);
                              }), 0))) {
                    var hyps = frm.frame.hyps;
                    var numOfArgs = hyps.length;
                    var args = new Array(numOfArgs);
                    var argsAreCorrect = true;
                    var argIdx = 0;
                    var maxArgIdx = numOfArgs - 1 | 0;
                    while(argIdx <= maxArgIdx && argsAreCorrect) {
                      var newExpr = MM_substitution.applySubs(hyps[argIdx].expr, subs, (function (param) {
                              throw {
                                    RE_EXN_ID: Common.MmException,
                                    _1: {
                                      msg: "Work variables are not supported in findAsrtParentsWithoutNewVars()."
                                    },
                                    Error: new Error()
                                  };
                            }));
                      var tmp;
                      switch (restrictExprLen) {
                        case "No" :
                            tmp = true;
                            break;
                        case "LessEq" :
                            tmp = newExpr.length <= exprLen;
                            break;
                        case "Less" :
                            tmp = newExpr.length < exprLen;
                            break;
                        
                      }
                      argsAreCorrect = tmp;
                      if (argsAreCorrect) {
                        var node = MM_proof_tree.ptGetNode(tree, newExpr);
                        args[argIdx] = node;
                        argsAreCorrect = !MM_proof_tree.pnIsInvalidFloating(node);
                      }
                      argIdx = argIdx + 1 | 0;
                    };
                    if (argsAreCorrect) {
                      onResult({
                            TAG: "Assertion",
                            args: args,
                            frame: frm.frame
                          });
                    }
                    
                  }
                  return "Continue";
                }));
        }));
}

function proveFloating(tree, node, frameRestrict, nodesToCreateParentsFor) {
  if (!(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && !MM_proof_tree.pnIsInvalidFloating(node))) {
    return ;
  }
  Common.arrayQueueReset(nodesToCreateParentsFor);
  var savedNodes = Belt_HashSetInt.make(128);
  var saveNodeToCreateParentsFor = function (node) {
    var match = MM_proof_tree.pnGetProof(node);
    if (match !== undefined) {
      return ;
    }
    var nodeId = MM_proof_tree.pnGetId(node);
    if (!Belt_HashSetInt.has(savedNodes, nodeId)) {
      Belt_HashSetInt.add(savedNodes, nodeId);
      return Common.arrayQueueAdd(nodesToCreateParentsFor, node);
    }
    
  };
  var saveArgs = function (src) {
    if (typeof src !== "object") {
      return ;
    }
    if (src.TAG !== "Assertion") {
      return ;
    }
    src.args.forEach(saveNodeToCreateParentsFor);
  };
  var getNextNodeToProve = function () {
    var nextNodeRef = Common.arrayQueuePop(nodesToCreateParentsFor);
    while(Belt_Option.mapWithDefault(nextNodeRef, false, (function (nextNode) {
              if (Belt_Option.isSome(MM_proof_tree.pnGetProof(nextNode))) {
                return true;
              } else {
                return MM_proof_tree.pnIsInvalidFloating(nextNode);
              }
            }))) {
      nextNodeRef = Common.arrayQueuePop(nodesToCreateParentsFor);
    };
    return nextNodeRef;
  };
  saveNodeToCreateParentsFor(node);
  var parentFound = {
    contents: false
  };
  var currNodeRef = getNextNodeToProve();
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && Belt_Option.isSome(currNodeRef)) {
    var curNode = Belt_Option.getExn(currNodeRef);
    var fParents = MM_proof_tree.pnGetFParents(curNode);
    if (fParents !== undefined) {
      fParents.forEach(saveArgs);
    } else {
      var curExpr = MM_proof_tree.pnGetExpr(curNode);
      var parent = findNonAsrtParent(tree, curExpr);
      if (parent !== undefined) {
        MM_proof_tree.pnAddParent(curNode, parent, false, false);
      } else {
        parentFound.contents = false;
        findAsrtParentsWithoutNewVars(tree, curExpr, "LessEq", frameRestrict, (function(curNode){
            return function (parent) {
              MM_proof_tree.pnAddParent(curNode, parent, false, false);
              saveArgs(parent);
              parentFound.contents = true;
            }
            }(curNode)));
        if (!parentFound.contents) {
          MM_proof_tree.pnSetInvalidFloating(curNode);
        }
        
      }
    }
    currNodeRef = getNextNodeToProve();
  };
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    return MM_proof_tree.pnSetInvalidFloating(node);
  }
  
}

function findAsrtParentsWithNewVars(tree, expr, args, exactOrderOfArgs, allowEmptyArgs, allowNewVars, allowNewDisjForExistingVars, frmsToUse, allowedFrms, combCntMax, debugLevelOpt, maxNumberOfResults, onProgress) {
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var floatingNodesToCreateParentsFor = Common.arrayQueueMake(1000);
  var applResults = [];
  var restrictFoundCnt = Belt_Option.isSome(maxNumberOfResults);
  var maxFoundCnt = Belt_Option.getWithDefault(maxNumberOfResults, 0);
  var isFrameAllowed = function (frame) {
    return MM_context.frameIsAllowed(frame, allowedFrms.inEssen);
  };
  var maxVarBeforeSearch = MM_proof_tree.ptGetMaxVar(tree);
  MM_asrt_apply.applyAssertions(maxVarBeforeSearch, MM_proof_tree.ptGetFrms(tree), frmsToUse, isFrameAllowed, (function (extra, extra$1) {
          return MM_proof_tree.ptIsDisjInCtx(tree, extra, extra$1);
        }), args, exactOrderOfArgs, allowEmptyArgs, allowNewVars, expr, MM_proof_tree.ptGetParenCnt(tree), allowNewDisjForExistingVars, combCntMax, (function (res) {
          applResults.push(res);
          var foundCnt = applResults.length;
          if (onProgress !== undefined && foundCnt % 100 === 0) {
            onProgress(foundCnt);
          }
          if (restrictFoundCnt && foundCnt >= maxFoundCnt) {
            return "Stop";
          } else {
            return "Continue";
          }
        }), debugLevel, undefined);
  var foundParents = [];
  applResults.forEach(function (applResult) {
        var frame = applResult.frame;
        var match = applResult.err;
        var exit = 0;
        if (match !== undefined && typeof match === "object") {
          switch (match.TAG) {
            case "NoUnifForAsrt" :
            case "NoUnifForArg" :
            case "NewVarsAreDisabled" :
                exit = 1;
                break;
            case "TooManyCombinations" :
                foundParents.push({
                      TAG: "AssertionWithErr",
                      args: [],
                      frame: frame,
                      err: Belt_Option.getExn(applResult.err)
                    });
                return ;
            default:
              exit = 2;
          }
        } else {
          exit = 2;
        }
        switch (exit) {
          case 1 :
              if (debugLevel !== 0) {
                foundParents.push({
                      TAG: "AssertionWithErr",
                      args: [],
                      frame: frame,
                      err: Belt_Option.getExn(applResult.err)
                    });
                return ;
              } else {
                return ;
              }
          case 2 :
              var applNewVarToTreeNewVar = Belt_MutableMapInt.make();
              applResult.newVars.forEach(function (applResNewVar, i) {
                    var newVarType = applResult.newVarTypes[i];
                    var treeNewVar = MM_proof_tree.ptAddNewVar(tree, newVarType);
                    Belt_MutableMapInt.set(applNewVarToTreeNewVar, applResNewVar, treeNewVar);
                  });
              var numOfArgs = frame.hyps.length;
              var args = new Array(numOfArgs);
              var unprovedFloating;
              var argIdx = 0;
              var maxArgIdx = numOfArgs - 1 | 0;
              while(argIdx <= maxArgIdx && (Belt_Option.isNone(unprovedFloating) || debugLevel !== 0)) {
                var argExpr = MM_substitution.applySubs(frame.hyps[argIdx].expr, applResult.subs, (function (param) {
                        throw {
                              RE_EXN_ID: Common.MmException,
                              _1: {
                                msg: "New work variables are not expected here [findAsrtParentsWithNewVars]."
                              },
                              Error: new Error()
                            };
                      }));
                var maxI = argExpr.length - 1 | 0;
                for(var i = 0; i <= maxI; ++i){
                  var sym = argExpr[i];
                  if (sym > maxVarBeforeSearch) {
                    var treeVar = Belt_MutableMapInt.get(applNewVarToTreeNewVar, sym);
                    var tmp;
                    if (treeVar !== undefined) {
                      tmp = treeVar;
                    } else {
                      throw {
                            RE_EXN_ID: Common.MmException,
                            _1: {
                              msg: "Could not replace an applVar with a treeVar."
                            },
                            Error: new Error()
                          };
                    }
                    argExpr[i] = tmp;
                  }
                  
                }
                var argNode = MM_proof_tree.ptGetNode(tree, argExpr);
                args[argIdx] = argNode;
                if (frame.hyps[argIdx].typ === "F" && Belt_Option.isNone(applResult.err) && Belt_Option.isNone(unprovedFloating)) {
                  proveFloating(tree, argNode, allowedFrms.inSyntax, floatingNodesToCreateParentsFor);
                  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(argNode))) {
                    unprovedFloating = MM_proof_tree.pnGetExpr(argNode);
                  }
                  
                }
                argIdx = argIdx + 1 | 0;
              };
              var match$1 = applResult.err;
              var err = match$1 !== undefined ? applResult.err : Belt_Option.map(unprovedFloating, (function (expr) {
                        return {
                                TAG: "UnprovedFloating",
                                expr: expr
                              };
                      }));
              if (err !== undefined) {
                if (debugLevel !== 0) {
                  foundParents.push({
                        TAG: "AssertionWithErr",
                        args: args,
                        frame: frame,
                        err: err
                      });
                  return ;
                } else {
                  return ;
                }
              } else {
                foundParents.push({
                      TAG: "Assertion",
                      args: args,
                      frame: frame
                    });
                return ;
              }
          
        }
      });
  return foundParents;
}

function proveWithoutJustification(tree, expr, allowedFrms, combCntMax) {
  var node = MM_proof_tree.ptGetNode(tree, expr);
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    var parents = findAsrtParentsWithNewVars(tree, expr, MM_proof_tree.ptGetRootStmts(tree).map(function (stmt) {
              return stmt.expr;
            }), false, false, false, false, undefined, allowedFrms, combCntMax, undefined, undefined, undefined);
    Expln_utils_common.arrForEach(parents, (function (parent) {
            MM_proof_tree.pnAddParent(node, parent, true, false);
            return MM_proof_tree.pnGetProof(node);
          }));
  }
  return node;
}

function getStatementsFromJustification(tree, jstf) {
  var getStmtByLabel = function (label) {
    var stmt = MM_proof_tree.ptGetRootStmts(tree).find(function (stmt) {
          return stmt.label === label;
        });
    if (stmt !== undefined) {
      return stmt.expr;
    }
    var hyp = MM_proof_tree.ptGetHypByLabel(tree, label);
    if (hyp !== undefined) {
      return hyp.expr;
    }
    
  };
  var foundStmts = jstf.args.map(getStmtByLabel).filter(Belt_Option.isSome).map(Belt_Option.getExn);
  if (foundStmts.length === jstf.args.length) {
    return foundStmts;
  }
  
}

function proveWithJustification(tree, expr, jstf, allowedFrms, combCntMax) {
  var findAsrtParents = function (args, debugLevel) {
    return findAsrtParentsWithNewVars(tree, expr, args, true, false, false, false, [jstf.label], allowedFrms, combCntMax, debugLevel, undefined, undefined);
  };
  var node = MM_proof_tree.ptGetNode(tree, expr);
  var args = getStatementsFromJustification(tree, jstf);
  if (args !== undefined && Belt_Option.getWithDefault(Belt_Option.map(MM_proof_tree.pnGetProof(node), (function (src) {
                return !MM_proof_tree.jstfEqSrc(args, jstf.label, src);
              })), true)) {
    Expln_utils_common.arrForEach(findAsrtParents(args, 0), (function (parent) {
            var requiredJstfIsFound = MM_proof_tree.jstfEqSrc(args, jstf.label, parent);
            MM_proof_tree.pnAddParent(node, parent, true, requiredJstfIsFound);
            if (requiredJstfIsFound) {
              return Caml_option.some(undefined);
            }
            
          }));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
      Expln_utils_common.arrForEach(findAsrtParents(args, 2), (function (parent) {
              var requiredJstfIsFound = MM_proof_tree.jstfEqSrc(args, jstf.label, parent);
              MM_proof_tree.pnAddParent(node, parent, true, requiredJstfIsFound);
              if (requiredJstfIsFound) {
                return Caml_option.some(undefined);
              }
              
            }));
    }
    
  }
  return node;
}

function srcIsBackRef(expr, src) {
  if (typeof src !== "object" || src.TAG !== "Assertion") {
    return false;
  } else {
    return src.args.some(function (arg) {
                return MM_context.exprEq(expr, MM_proof_tree.pnGetExpr(arg));
              });
  }
}

function proveBottomUp(tree, expr, getParents, maxSearchDepth, onProgress) {
  var nodesToCreateParentsFor = Belt_MutableQueue.make();
  var maxSearchDepthStr = String(maxSearchDepth);
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, (function (param) {
          
        }), undefined);
  MM_proof_tree.ptClearDists(tree);
  var rootNode = MM_proof_tree.ptGetNode(tree, expr);
  MM_proof_tree.pnSetDist(rootNode, 0);
  Belt_MutableQueue.add(nodesToCreateParentsFor, rootNode);
  var lastDist = 0;
  var maxCnt = 1;
  var cnt = 0;
  var onProgressP = Belt_Option.map(onProgress, (function (onProgress) {
          return function (numOfParents) {
            onProgress("Proving bottom-up: 0/" + maxSearchDepthStr + " " + String(numOfParents));
          };
        }));
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(rootNode)) && !Belt_MutableQueue.isEmpty(nodesToCreateParentsFor)) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(curNode))) {
      var dist = MM_proof_tree.pnGetDist(curNode);
      var curDist;
      if (dist !== undefined) {
        curDist = dist;
      } else {
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "Encountered a node without dist."
              },
              Error: new Error()
            };
      }
      if (onProgress !== undefined) {
        if (lastDist !== curDist) {
          onProgressP = undefined;
          lastDist = curDist;
          var curDistStr = String(curDist);
          progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, (function(curDistStr){
              return function (pct) {
                var pctStr = String(Math.round(pct * 100) | 0);
                onProgress("Proving bottom-up: " + curDistStr + "/" + maxSearchDepthStr + " " + pctStr + "%");
              }
              }(curDistStr)), undefined);
          maxCnt = Belt_MutableQueue.size(nodesToCreateParentsFor) + 1 | 0;
          cnt = 0;
        }
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, cnt / maxCnt);
        cnt = cnt + 1 | 0;
      }
      var curExpr = MM_proof_tree.pnGetExpr(curNode);
      var parent = findNonAsrtParent(tree, curExpr);
      if (parent !== undefined) {
        MM_proof_tree.pnAddParent(curNode, parent, true, false);
      } else {
        var newDist = curDist + 1 | 0;
        if (newDist <= maxSearchDepth) {
          getParents(curExpr, curDist, onProgressP).forEach((function(curNode,curExpr,newDist){
              return function (src) {
                if (srcIsBackRef(curExpr, src)) {
                  return ;
                }
                MM_proof_tree.pnAddParent(curNode, src, true, false);
                if (typeof src !== "object") {
                  return ;
                }
                if (src.TAG !== "Assertion") {
                  return ;
                }
                src.args.forEach(function (arg) {
                      if (Belt_Option.isNone(MM_proof_tree.pnGetProof(arg)) && Belt_Option.isNone(MM_proof_tree.pnGetDist(arg))) {
                        MM_proof_tree.pnSetDist(arg, newDist);
                        return Belt_MutableQueue.add(nodesToCreateParentsFor, arg);
                      }
                      
                    });
              }
              }(curNode,curExpr,newDist)));
        }
        
      }
    }
    
  };
}

function isInCorrectOrder(min, i, max) {
  if (min !== undefined) {
    if (min <= i) {
      if (max !== undefined) {
        return i <= max;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else if (max !== undefined) {
    return i <= max;
  } else {
    return true;
  }
}

function exprMatchesAsrtMatchers(expr, matchers, parenCnt) {
  if (matchers !== undefined) {
    return matchers.some(function (matcher) {
                if (!matcher.matchAsrt) {
                  return true;
                }
                var frm = matcher.frm;
                if (expr[0] !== frm.frame.asrt[0]) {
                  return false;
                }
                var res = {
                  contents: false
                };
                MM_substitution.iterateSubstitutions(frm.frame.asrt, expr, frm.frmConstParts[frm.numOfHypsE], frm.constParts[frm.numOfHypsE], frm.varGroups[frm.numOfHypsE], frm.subs, parenCnt, (function (param) {
                        res.contents = true;
                        return "Stop";
                      }));
                return res.contents;
              });
  } else {
    return true;
  }
}

function proveStmtBottomUp(tree, expr, params, allowedFrms, combCntMax, debugLevel, onProgress) {
  var getParents = function (expr, dist, onProgress) {
    var res = [];
    for(var i = 0 ,i_finish = params.frameParams.length; i < i_finish; ++i){
      var paramsI = params.frameParams[i];
      if (isInCorrectOrder(paramsI.minDist, dist, paramsI.maxDist) && exprMatchesAsrtMatchers(expr, paramsI.matches, MM_proof_tree.ptGetParenCnt(tree))) {
        var parents = findAsrtParentsWithNewVars(tree, expr, paramsI.args, false, paramsI.allowNewStmts, paramsI.allowNewVars, paramsI.allowNewDisjForExistingVars, paramsI.frmsToUse, allowedFrms, combCntMax, debugLevel, paramsI.maxNumberOfBranches, onProgress);
        var match = paramsI.lengthRestrict;
        var parents$1;
        var exit = 0;
        switch (match) {
          case "No" :
              parents$1 = parents;
              break;
          case "LessEq" :
          case "Less" :
              exit = 1;
              break;
          
        }
        if (exit === 1) {
          var exprLen = expr.length;
          parents$1 = parents.filter((function(paramsI,exprLen){
              return function (parent) {
                if (typeof parent !== "object") {
                  return true;
                }
                if (parent.TAG !== "Assertion") {
                  return true;
                }
                var frame = parent.frame;
                var args = parent.args;
                var argsAreCorrect = true;
                var numOfArgs = frame.hyps.length;
                var maxArgIdx = numOfArgs - 1 | 0;
                var argIdx = 0;
                while(argIdx <= maxArgIdx && argsAreCorrect) {
                  var arg = args[argIdx];
                  if (frame.hyps[argIdx].typ === "E") {
                    var match = paramsI.lengthRestrict;
                    var tmp;
                    switch (match) {
                      case "No" :
                          tmp = true;
                          break;
                      case "LessEq" :
                          tmp = MM_proof_tree.pnGetExpr(arg).length <= exprLen;
                          break;
                      case "Less" :
                          tmp = MM_proof_tree.pnGetExpr(arg).length < exprLen;
                          break;
                      
                    }
                    argsAreCorrect = tmp;
                  }
                  argIdx = argIdx + 1 | 0;
                };
                return argsAreCorrect;
              }
              }(paramsI,exprLen)));
        }
        var matchers = paramsI.matches;
        var parents$2 = matchers !== undefined ? parents$1.filter((function(matchers){
              return function (parent) {
                return matchers.some(function (matcher) {
                            return MM_apply_asrt_matcher.exprSrcMatches(expr, parent, matcher, MM_proof_tree.ptGetParenCnt(tree));
                          });
              }
              }(matchers))) : parents$1;
        res.push(parents$2);
      }
      
    }
    return Belt_Array.concatMany(res);
  };
  proveBottomUp(tree, expr, getParents, params.maxSearchDepth, onProgress);
  return MM_proof_tree.ptGetNode(tree, expr);
}

function proveStmt(tree, expr, jstf, bottomUpProverParams, allowedFrms, combCntMax, debugLevel, onProgress) {
  if (bottomUpProverParams !== undefined) {
    proveStmtBottomUp(tree, expr, bottomUpProverParams, allowedFrms, combCntMax, debugLevel, onProgress);
  } else if (jstf !== undefined) {
    proveWithJustification(tree, expr, jstf, allowedFrms, combCntMax);
  } else {
    proveWithoutJustification(tree, expr, allowedFrms, combCntMax);
  }
}

function makeExprToStr(ctx, ctxMaxVar) {
  if (!MM_context.isDebug(ctx)) {
    return ;
  }
  var intToSym = function (i) {
    if (i <= ctxMaxVar) {
      return MM_context.ctxIntToSymExn(ctx, i);
    } else {
      return "&" + String(i);
    }
  };
  return (function (expr) {
            return expr.map(intToSym).join(" ");
          });
}

function createProofTree(proofCtx, frms, parenCnt) {
  var ctxMaxVar = MM_context.getNumOfVars(proofCtx) - 1 | 0;
  var hyps = MM_context.getAllHyps(proofCtx);
  var tree = MM_proof_tree.ptMake(frms, hyps, ctxMaxVar, MM_context.getAllDisj(proofCtx), parenCnt, makeExprToStr(proofCtx, ctxMaxVar));
  Belt_MapString.forEach(hyps, (function (label, hyp) {
          if (hyp.typ !== "E") {
            return ;
          }
          var node = MM_proof_tree.ptGetNode(tree, hyp.expr);
          MM_proof_tree.pnAddParent(node, {
                TAG: "Hypothesis",
                label: label
              }, true, false);
          MM_proof_tree.ptAddRootStmt(tree, {
                isHyp: true,
                label: label,
                expr: hyp.expr,
                jstf: undefined
              });
        }));
  return tree;
}

function proveFloatings(wrkCtx, frms, frameRestrict, floatingsToProve, parenCnt) {
  var tree = createProofTree(wrkCtx, frms, parenCnt);
  var floatingNodesToCreateParentsFor = Common.arrayQueueMake(1000);
  floatingsToProve.forEach(function (expr) {
        proveFloating(tree, MM_proof_tree.ptGetNode(tree, expr), frameRestrict, floatingNodesToCreateParentsFor);
      });
  return tree;
}

function proveSyntaxTypes(proofTree, wrkCtx, frms, frameRestrict, parenCnt, exprs, syntaxTypes, onProgress) {
  if (Belt_Option.isNone(proofTree) && (Belt_Option.isNone(wrkCtx) || Belt_Option.isNone(frms) || Belt_Option.isNone(parenCnt))) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Either proofTree or (wrkCtx and frms and parenCnt) should be passed."
          },
          Error: new Error()
        };
  }
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined);
  var tree = proofTree !== undefined ? Caml_option.valFromOption(proofTree) : createProofTree(Belt_Option.getExn(wrkCtx), Belt_Option.getExn(frms), Belt_Option.getExn(parenCnt));
  if (syntaxTypes.length === 0) {
    return tree;
  }
  var floatingNodesToCreateParentsFor = Common.arrayQueueMake(1000);
  var lastType = syntaxTypes[0];
  for(var ei = 0 ,ei_finish = exprs.length; ei < ei_finish; ++ei){
    var expr = exprs[ei];
    var node = MM_proof_tree.ptGetNode(tree, [lastType].concat(expr));
    proveFloating(tree, node, frameRestrict, floatingNodesToCreateParentsFor);
    var ti = 0;
    while(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && ti < syntaxTypes.length) {
      var typ = syntaxTypes[ti];
      ti = ti + 1 | 0;
      if (typ !== lastType) {
        node = MM_proof_tree.ptGetNode(tree, [typ].concat(expr));
        proveFloating(tree, node, frameRestrict, floatingNodesToCreateParentsFor);
      }
      
    };
    var match = MM_proof_tree.pnGetProof(node);
    if (match !== undefined) {
      MM_proof_tree.ptAddSyntaxProof(tree, expr, node);
      lastType = MM_proof_tree.pnGetExpr(node)[0];
    }
    MM_progress_tracker.progressTrackerSetCurrPct(progressState, (ei + 1 | 0) / exprs.length);
  }
  return tree;
}

function createProofCtx(wrkCtx, rootStmts) {
  var proofCtx = MM_context.createContext(Caml_option.some(wrkCtx), undefined);
  rootStmts.forEach(function (stmt) {
        if (stmt.isHyp) {
          return MM_context.applySingleStmt(proofCtx, {
                      TAG: "Essential",
                      label: stmt.label,
                      expr: MM_context.ctxIntsToSymsExn(wrkCtx, stmt.expr)
                    }, undefined, undefined, undefined, undefined);
        }
        
      });
  return proofCtx;
}

function unifyAll(wrkCtx, frms, rootStmts, parenCnt, bottomUpProverParams, allowedFrms, combCntMax, syntaxTypes, exprsToSyntaxCheck, debugLevelOpt, onProgress) {
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, Belt_Option.map(onProgress, (function (onProgress) {
              return function (pct) {
                onProgress("Unifying all: " + Common.floatToPctStr(pct));
              };
            })), undefined);
  var proofCtx = createProofCtx(wrkCtx, rootStmts);
  var tree = createProofTree(proofCtx, frms, parenCnt);
  if (syntaxTypes !== undefined && syntaxTypes.length > 0 && exprsToSyntaxCheck !== undefined) {
    proveSyntaxTypes(Caml_option.some(tree), undefined, undefined, allowedFrms.inSyntax, undefined, exprsToSyntaxCheck, syntaxTypes, Belt_Option.map(onProgress, (function (onProgress) {
                return function (pct) {
                  onProgress("Checking syntax: " + Common.floatToPctStr(pct));
                };
              })));
  }
  var rootProvables = rootStmts.filter(function (stmt) {
        return !stmt.isHyp;
      });
  var numOfStmts = rootProvables.length;
  var maxStmtIdx = numOfStmts - 1 | 0;
  rootProvables.forEach(function (stmt, stmtIdx) {
        proveStmt(tree, stmt.expr, stmt.jstf, stmtIdx === maxStmtIdx ? bottomUpProverParams : undefined, allowedFrms, combCntMax, debugLevel, stmtIdx !== maxStmtIdx || Belt_Option.isNone(bottomUpProverParams) ? undefined : onProgress);
        MM_proof_tree.ptAddRootStmt(tree, stmt);
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, (stmtIdx + 1 | 0) / numOfStmts);
      });
  return tree;
}

function getOrderedSubarray(arr, start, end) {
  return arr.slice(start, end).sort();
}

function compareUnorderedSubArrays(arr1, arr2, start, end) {
  return Caml_obj.equal(getOrderedSubarray(arr1, start, end), getOrderedSubarray(arr2, start, end));
}

function makeParenCnt(ctx, parens) {
  var match = MM_context.ctxGetOptimizedConstsOrder(ctx, parens);
  var canBeLastMax = match.canBeLastMax;
  var canBeLastMin = match.canBeLastMin;
  var canBeFirstMax = match.canBeFirstMax;
  var canBeFirstMin = match.canBeFirstMin;
  var parenMin = match.parenMin;
  var allConsts = match.allConsts;
  var allConstsActual = MM_context.getAllConsts(ctx);
  if (allConsts.length !== allConstsActual.length) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "allConsts.length != allConstsActual.length"
          },
          Error: new Error()
        };
  }
  if (parenMin < 0 && Caml_obj.notequal(allConsts.slice(0, -parenMin | 0), allConstsActual.slice(0, -parenMin | 0))) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "allConsts.parens != allConstsActual.parens"
          },
          Error: new Error()
        };
  }
  if (canBeFirstMin <= canBeFirstMax && !compareUnorderedSubArrays(allConsts, allConstsActual, (-canBeFirstMax | 0) - 1 | 0, -canBeFirstMin | 0)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "allConsts.canBeFirst != allConstsActual.canBeFirst"
          },
          Error: new Error()
        };
  }
  if (canBeLastMin <= canBeLastMax && !compareUnorderedSubArrays(allConsts, allConstsActual, (-canBeLastMax | 0) - 1 | 0, -canBeLastMin | 0)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "allConsts.canBeLast != allConstsActual.canBeLast"
          },
          Error: new Error()
        };
  }
  if (!compareUnorderedSubArrays(allConsts, allConstsActual, 0, allConsts.length)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "allConsts.remaining != allConstsActual.remaining"
          },
          Error: new Error()
        };
  }
  return MM_parenCounter.parenCntMake(parenMin, canBeFirstMin, canBeFirstMax, canBeLastMin, canBeLastMax);
}

exports.bottomUpProverParamsMakeDefault = bottomUpProverParamsMakeDefault;
exports.lengthRestrictToStr = lengthRestrictToStr;
exports.lengthRestrictFromStr = lengthRestrictFromStr;
exports.lengthRestrictFromStrExn = lengthRestrictFromStrExn;
exports.createProofCtx = createProofCtx;
exports.proveFloatings = proveFloatings;
exports.proveSyntaxTypes = proveSyntaxTypes;
exports.unifyAll = unifyAll;
exports.makeParenCnt = makeParenCnt;
/* Common Not a pure module */
